import { UsuarioXRolXUnidad } from './usuario-x-rol-x-unidad';
import { UnidadAdministrativa } from './unidad-administrativa';

export class UsuarioXRolXUnidadDTO {

    usuarioXRolXUnidad: UsuarioXRolXUnidad;
	
    unidades: UnidadAdministrativa[] = [];
    

}
